import { render, staticRenderFns } from "./FormularioDesenvolvimento.vue?vue&type=template&id=206203bb&"
import script from "./FormularioDesenvolvimento.vue?vue&type=script&lang=js&"
export * from "./FormularioDesenvolvimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports